import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {EnumerationService} from '../../services/enumeration.service';
import {ExcCoreModule} from 'exc-core-v2';

@Component({
  selector: 'app-exg-select-enumeration',
  templateUrl: './exg-select-enumeration.component.html',
})
export class ExgSelectEnumerationComponent implements OnInit, OnChanges {
  @Input() caption!: string;
  @Input() listDisplay = 'enmText';
  @Input() listIdent = 'enmIdent';
  @Input() disabled = false;
  @Input() required = false;
  @Input() enumerationName = '';
  @Input() enumerationList = [] as any[];
  @Input() sortAlphabetical = false;

  @Output() valueChange = new EventEmitter<any>();

  init = true;
  list = [] as any[];
  _value: any = null;
  _valueIndex: any = null;

  get value(): any {
    return this._value;
  }

  @Input()
  set value(obj: any) {
    obj = obj || 0;
    this._value = obj;
    this._valueIndex = this.list.indexOf(this.list.find((element: any) => element[this.listIdent] === obj)) ;
  }

  get valueIndex(): any {
    return this._valueIndex;
  }

  set valueIndex(obj: any) {
    this._valueIndex = obj;
    this._value = this.list[obj][this.listIdent];

    this.valueChange.emit(this._value);
  }

  constructor(
    private enumSvc: EnumerationService
  ) {
  }


  ngOnInit(): void {
    this.updateList();
    this.value = this._value;
    if (!this._value && this.list && ExcCoreModule.Array.GetObject(this.list, 'enmDefault', true)) {
      this.value = ExcCoreModule.Array.GetObject(this.list, 'enmDefault', true).enmIdent;
      this.valueChange.emit(this._value);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.enumerationName && !changes.enumerationName.isFirstChange()) {
      this.updateList();
    }
  }

  private updateList(): void {
    if (this.enumerationName && this.enumerationName.length !== 0) {
      this.list = this.enumSvc.getEnumerationList(this.enumerationName);
    } else if (this.enumerationList && this.enumerationList.length > 0) {
      this.list = this.enumerationList;
    }

    if (this.sortAlphabetical) {
      this.list.sort((a, b) => a[this.listDisplay].localeCompare(b[this.listDisplay]));
    }
  }
}
